module.exports = "/images/ny-life2-15.jpg";